// extracted by mini-css-extract-plugin
module.exports = {"sidedrawerLeft":"SideDrawer_sidedrawerLeft__xsoQ-","open":"SideDrawer_open__XH0M5","sidedrawerRight":"SideDrawer_sidedrawerRight__1Ok5k"};